import { AccuracyProviderDropdownTypes, ExportProviderAvailabilityType } from "@app/exports/enumerations";
import { ProviderNetworkType } from "@app/projects/enumerators";
import { QESSelect } from "@app/shared/qes-standards";
import { filter, some } from "lodash";
import { Component } from "react";

interface AccuracySelectProviderFilterProps {
  networkTypes: ProviderNetworkType[];
  onProviderFilterTypeChange: (filterType: ProviderNetworkType) => void;
  providerFilter: {
    filterType: ProviderNetworkType;
    providerAvailabilityType: ExportProviderAvailabilityType;
  };
  providerIds: number[];
}

export default class AccuracySelectProviderFilter extends Component<AccuracySelectProviderFilterProps> {

  private providerTypes = [
    { key: AccuracyProviderDropdownTypes.Network, value: "Network Providers" }
  ];

  public render() {
    const hasProviderIds = this.props.providerIds.length > 0;

    const filteredProviderTypes = Array.from(filter(this.providerTypes, ({ key }) => some(this.props.networkTypes, (nt) => nt.valueOf() === key.valueOf())));
    return (
      <>
        <p className="lead mb0 font-weight-bold">Provider Filter{hasProviderIds && <span>: Selected</span>}</p>
        <p>Please select the providers to include:</p>
        <div className="form-group row">
          <div className="col-lg-12 ptb0">
            <QESSelect
              label="Provider Type"
              hideLabel={true}
              testId="accuracy-select-providers-filter"
              disabled={hasProviderIds || this.props.providerFilter.providerAvailabilityType === ExportProviderAvailabilityType.Changed}
              className="form-control"
              value={this.props.providerFilter.filterType}
              onChange={(e) => this.props.onProviderFilterTypeChange(e.target.value as ProviderNetworkType)}
            >
              {filteredProviderTypes.map(({ key, value }) => (
                <option key={key} value={key}>{value}</option>
              ))}
            </QESSelect>
          </div>
        </div>
      </>
    );
  }
}
